<template>
  <button
    class="btn btn-primary"
    :class="{ 'w-full': block }"
    :type="type"
    :disabled="disabled"
    v-on="$listeners"
  >
    <span class="z-1 relative flex items-center justify-center">
      <template v-if="!!$slots.default">
        <slot></slot>
      </template>
      <template v-else>{{ label }}</template>
    </span>
  </button>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { LocaleMessages } from 'vue-i18n';

@Component({
  name: 'app-button',
})
export default class Button extends Vue {
  @Prop({ type: [String, Object], default: '' }) label!:
    | string
    | LocaleMessages;
  @Prop({ type: String, default: 'button' }) type!: string;
  @Prop({ type: Boolean, default: false }) disabled!: boolean;
  @Prop({ type: Boolean, default: false }) block!: boolean;
}
</script>

<style scoped>
.btn {
  @apply relative px-4 py-3 text-sm font-medium leading-4 rounded-full;
}

.btn:disabled::before {
  @apply opacity-20 grayscale filter;
}

.btn::before {
  @apply absolute z-0 bottom-0 left-0 right-0 top-0 transition-all filter;
  border-radius: inherit;
  content: '';
}

.btn-primary:hover:not(:disabled)::before {
  @apply brightness-75;
}

.btn-primary {
  @apply text-white;
}

.btn-primary::before {
  @apply bg-primary;
}
</style>
